export default function ComparisonChecklist() {
  const checklistItems = [
    {
      category: 'Certifications & Licensing',
      items: [
        'NABCEP certified installers',
        'Texas electrical contractor license',
        'Manufacturer certifications',
        'Insurance and bonding coverage'
      ]
    },
    {
      category: 'Experience & Track Record',
      items: [
        'Years installing solar in El Paso',
        'Number of completed installations',
        'Commercial and residential portfolio',
        'Customer references available'
      ]
    },
    {
      category: 'Equipment Quality',
      items: [
        'Tier 1 solar panel brands',
        'Inverter quality and warranty',
        'Mounting system durability',
        'Battery storage options'
      ]
    },
    {
      category: 'Financial Considerations',
      items: [
        'Detailed cost breakdown',
        'Financing options available',
        'Help with tax credits and incentives',
        'ROI and payback period estimates'
      ]
    },
    {
      category: 'Installation & Service',
      items: [
        'Site assessment and design',
        'Permit and interconnection handling',
        'Installation timeline',
        'System monitoring and maintenance'
      ]
    },
    {
      category: 'Warranties & Support',
      items: [
        'Panel performance warranty (25+ years)',
        'Inverter warranty coverage',
        'Workmanship warranty',
        'Post-installation support'
      ]
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Solar Contractor Comparison Checklist
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Essential factors to evaluate when comparing solar installation contractors for your El Paso property
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {checklistItems.map((section, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-md"
            >
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-500 text-white rounded-lg">
                  <i className="ri-checkbox-circle-line text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900">
                  {section.category}
                </h3>
              </div>
              
              <ul className="space-y-3">
                {section.items.map((item, idx) => (
                  <li 
                    key={idx}
                    className="flex items-start gap-3 text-gray-700"
                  >
                    <i className="ri-check-line text-amber-500 text-lg mt-0.5 flex-shrink-0"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-amber-50 rounded-xl p-8 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Ready to Go Solar?
          </h3>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
            Get free quotes from multiple certified solar contractors in El Paso and start saving on your energy bills with clean, renewable power
          </p>
          <button className="px-8 py-4 bg-amber-500 text-white rounded-lg font-semibold hover:bg-amber-600 transition-colors whitespace-nowrap cursor-pointer">
            Get Free Solar Quotes
          </button>
        </div>
      </div>
    </section>
  );
}
